<template>
    <div>
		<template v-if="!isInitialized">
 			<van-empty description="正在读取中..."/>
        </template>
        <van-empty v-if="cardList.length <= 0 && isInitialized" description="暂无卡片可办理" />
		<div v-if="cardList.length > 0 && isInitialized">
			<div class="card" v-for="(item, index) in cardList" :key="index" :style="!!item.background_image && `backgroundImage: url(${item.background_image})`" @click="cardDetailClick(item)">
				<div class="card-name">
					<van-tag color="rgba(87,107,149,0.7)" size="large">{{item.name}}</van-tag>
				</div>
				<div class="card-tag color-theme">
					<span>{{$store.state.systemEnum['card_type'][item.type]['name']}}</span>
				</div>
			</div>
		</div>

        <van-popup v-model="cardDetailShow" position="bottom" round>
            <div class="card" :style="{ backgroundImage: cardDetailItem.background_image ? 'url(' + cardDetailItem.background_image + ')' : '', margin: '30px 30px 20px' }">
                <div class="card-name">
                    <van-tag color="rgba(87,107,149,0.7)" size="large">{{cardDetailItem.name}}</van-tag>
                </div>
                <div class="card-tag color-theme">
                    <span>{{cardDetailItem.type ? $store.state.systemEnum['card_type'][cardDetailItem.type]['name'] : ''}}</span>
                </div>
            </div>

            <div class="card-detail-container">
                <van-list>
                    <van-cell title="有效期限">
                        <span>{{validityTime}}</span>
                    </van-cell>

                    <van-cell class="card-cell-explain" v-if="cardDetailItem.is_needle_car_auth">
                        <div class="card-cell-title">所需认证类型</div>
                        <div class="card-cell-content">{{authTypeString(cardDetailItem.car_auth_type)}}</div>
                    </van-cell>

                    <van-cell class="card-cell-explain" v-if="cardDetailItem.explain">
                        <div class="card-cell-title">说明</div>
                        <div class="card-cell-content">{{cardDetailItem.explain}}</div>
                    </van-cell>
                    <van-cell class="card-cell-explain">
                        <div class="card-cell-title">办卡站点</div>
                        <van-radio-group class="card-cell-content" v-model="site" direction="horizontal">
                            <van-radio checked-color="#07c160" style="margin-bottom: 10px;" v-for="(val, key) in cardDetailItem.useable_site_enum" :name="key" :key="key">{{val}}</van-radio>
                        </van-radio-group>
                    </van-cell>

                    <van-cell class="card-cell-explain" v-if="$store.state.systemConfig['handle_card_service_clause.is_enable']">
                        <div class="card-cell-title">其他事项</div>
						<van-checkbox v-model="isAgreed" label-disabled>
							我已阅读并同意<span class="link" @click="showClause = true">《{{$store.state.systemConfig['handle_card_service_clause.title']}}》</span>
						</van-checkbox>
                    </van-cell>

                    <van-button style="margin-top: 20px;" class="base-theme-button linear-button" block @click="addCard" :disabled="isDisabled">办卡</van-button>
                </van-list>
            </div>
        </van-popup>

		<van-popup v-model="showClause" round class="clause_popup">
			<van-row type="flex" justify="center">
				<span class="text-title">《{{$store.state.systemConfig['handle_card_service_clause.title']}}》</span>
			</van-row>
			<van-row style="height: 70vh;overflow-y: scroll">
				<pre>{{$store.state.systemConfig['handle_card_service_clause.content']}}</pre>
			</van-row>
			<van-row type="flex" justify="center">
				<span class="text-btn" @click="showClause = false">关闭</span>
			</van-row>
		</van-popup>

    </div>
</template>

<script>
    import api from "../../assets/js/api";
    import { Dialog } from 'vant';

    export default {
        name: "Handle",
        data(){
            return {
                cardList : [],
                cardDetailItem : {},
                cardDetailShow : false,
                site : '',
				isLoading: false,
				isInitialized: false,
				showClause: false,
				isAgreed: false
            };
        },
        computed : {
            validityTime(){
                if(this.cardDetailItem.validity_year === 0 && this.cardDetailItem.validity_month === 0 && this.cardDetailItem.validity_day === 0){
                    return '永久有效';
                }
                let str = '';
                str = this.cardDetailItem.validity_year > 0 ? this.cardDetailItem.validity_year + '年' : '';
                str = this.cardDetailItem.validity_month > 0 ? this.cardDetailItem.validity_month + '月' : '';
                str = this.cardDetailItem.validity_day > 0 ? this.cardDetailItem.validity_day + '日' : '';
                return str;
            },
            authTypes: function() {
                return this.$store.state.systemEnum.company.user_car_auth ? this.$store.state.systemEnum.company.user_car_auth.auth_type : '';
            },
			isDisabled() {
				return this.$store.state.systemConfig['handle_card_service_clause.is_enable'] ? this.isLoading || !this.isAgreed : this.isLoading
			}
        },
        created() {
            let self = this;
            api.request('/card/list').then(res => {
                self.cardList = res.data;
            }).finally(() => {
				this.isInitialized =true;
			});
        },
        methods : {
            cardDetailClick(item){
                this.cardDetailShow = true;
                this.cardDetailItem = item;
            },
            authTypeString(types) {
                let resStr = '';
                let self = this;
                types.forEach(item => {
                    resStr += self.authTypes[item] + ','
                });
                return resStr.substring(0, resStr.length - 1);
            },
            // 办卡
            addCard () {
				if (this.isLoading) return
				this.isLoading = true
                let self = this;
                if (!this.site) {
                    return this.$notify({ type: 'warning', message: '请选择站点' })
                }
                api.request('/user_card/handle', {
                    card_id: this.cardDetailItem.id,
                    handle_site_id: this.site
                }).then(res => {
                    Dialog.alert({
                        message: res.msg,
                    }).then(() => {
                        self.$router.back();
                    });
                }).catch(err => {
                    self.$notify({ type: 'danger', message: err.msg })
                    if (err.code == '3000') {
                        self.$dialog.confirm({
                        title: '需要认证',
                        message: '是否跳转至申请认证页面',})
                        .then(() => {
                            self.$router.push({ name : 'Certification' });
                        })
                        .catch(() => {
                            // on cancel
                        });
                    }
                }).finally(() => {
					this.isLoading = false
				})
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../style/base.scss';
    *{
        @include themeify{
            .card {
                background-size: 100% 100%;
                border-radius: 10px;
                height: 40vw;
                box-shadow: 0 0 10px 0 rgba(200,200,200,.8);
                color: #FFF;
                margin: 30px 20px 20px;
                padding-top: 10px;
                background-image: url("../../assets/images/oilcard_bg.png");
                position: relative;

                .card-name {
                    position: absolute;
                    left: 15px;
                    bottom: 10px;
                    font-size: 18px;
                    border-radius: 25%;
                }

                .card-tag{
                    background-size: auto 100%;
                    background-position-x: -59px;
                    height: 30px;
                    position: absolute;
                    right: 0;
                    top: -15px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-radius:0 0.3rem 0 0.3rem;

                    &.color-theme {
                        background: linear-gradient(180deg, themed('colorGradientLeft') 0%, themed('colorGradientRight') 100%);
                    }

                    &.color-vip {
                        background: linear-gradient(90deg, #AC640D 0%, #FED7AB 100%);
                    }

                    > span{
                        display: block;
                        padding:0 25px;
                        font-size: 14px;
                    }
                }
            }

            .card-detail-container{
                padding: 10px 30px 0;
                margin-bottom: 30px;
                .van-cell {
                    padding-left: 0;
                    padding-right: 0;
                }
            }

            .card-cell-explain{
                position: relative;
                padding: 10px 0 0;

                &:after{
                    position: absolute;
                    box-sizing: border-box;
                    content: ' ';
                    pointer-events: none;
                    right: 20px;
                    bottom: 0;
                    left: 20px;
                    border-bottom: 1px solid #ebedf0;
                    -webkit-transform: scaleY(.5);
                    transform: scaleY(.5);
                }
                .card-cell-title{
                    margin-bottom: 5px;
                }
                .card-cell-content{
                    color: #969799;
                    word-wrap: break-word!important;
                    white-space: pre-wrap!important;
                    *white-space:normal!important;
                }
            }

			.link {
				color: #1989fa;
			}

			.clause_popup {
				width: 70vw;
				padding: 20px;
				font-size: 12px;
				color: #333;
			}

			.text-btn {
				margin-top: 10px;
				color: #1989fa;
				font-size: 14px;
			}

			.text-title {
				overflow: hidden;
				text-overflow:ellipsis;
				white-space: nowrap;
				margin-bottom: 15px;
				font-size: 16px;
				color: #333;
			}
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/card/Handle.vue